import React, { useState } from 'react';
import { FileSpreadsheetIcon, CalendarIcon } from 'lucide-react';
import { Modal } from './Modal';
import { Button } from './Button';
import { Input } from './Input';
import { Select } from './Select';
interface ExcelExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExport: (dateFrom: string | null, dateTo: string | null, status: string | null, patientId: string | null) => void | Promise<void>;
  title: string;
  isExporting?: boolean;
  // Opciones para los filtros adicionales de estado y paciente.
  statusOptions?: {
    value: string;
    label: string;
  }[];
  patientOptions?: {
    value: string;
    label: string;
  }[];
}
export function ExcelExportModal({
  isOpen,
  onClose,
  onExport,
  title,
  isExporting = false,
  statusOptions = [],
  patientOptions = []
}: ExcelExportModalProps) {
  const [useDateRange, setUseDateRange] = useState(false);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [status, setStatus] = useState('');
  const [patientId, setPatientId] = useState('');
  const handleClose = () => {
    if (isExporting) return;
    onClose();
  };
  const handleExportAll = async () => {
    await onExport(null, null, status || null, patientId || null);
  };
  const handleExportRange = async () => {
    if (!dateFrom || !dateTo) return;
    await onExport(dateFrom, dateTo, status || null, patientId || null);
  };
  return <Modal isOpen={isOpen} onClose={handleClose} title={title} size="sm" icon={<FileSpreadsheetIcon className="w-4 h-4" data-id="element-6367" data-mp="1yea62nb0gwmy" />} accentColor="emerald" footer={<div className="flex items-center justify-end gap-2" data-id="element-6368" data-mp="1tckr4wko3ytl">
          <Button variant="ghost" onClick={handleClose} disabled={isExporting} data-id="element-6369" data-mp="1og41fxxtlcee">
            Cancelar
          </Button>
          {useDateRange ? <Button variant="primary" onClick={handleExportRange} isLoading={isExporting} disabled={!dateFrom || !dateTo} data-id="element-6370" data-mp="hx5tdqkmx2xf">
          
              Exportar rango
            </Button> : <Button variant="primary" onClick={handleExportAll} isLoading={isExporting} data-id="element-6371" data-mp="jgfjc7gpgypv">
              Exportar todo
            </Button>}
        </div>} data-id="element-6366" data-mp="22earirwj283i">
      
      <div className="space-y-4" data-id="element-6372" data-mp="5ir0f56781ng">
        <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-6373" data-mp="afhg3re3cv8c">
          Elige si deseas exportar todos los registros o filtrar por un rango de fechas antes de generar el archivo de Excel.
        </p>

        <div className="flex gap-2 p-1 bg-gray-100 dark:bg-white/[0.06] rounded-xl" data-id="element-6374" data-mp="i3aynxmbsvc">
          <button type="button" onClick={() => setUseDateRange(false)} className={`flex-1 py-2 text-sm font-medium rounded-lg transition-all ${!useDateRange ? 'bg-white dark:bg-white/[0.12] text-gray-900 dark:text-white shadow-sm' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-6375" data-mp="3ivj6rqd5uxww">
            
            Todos los registros
          </button>
          <button type="button" onClick={() => setUseDateRange(true)} className={`flex-1 py-2 text-sm font-medium rounded-lg transition-all ${useDateRange ? 'bg-white dark:bg-white/[0.12] text-gray-900 dark:text-white shadow-sm' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-6376" data-mp="2u9v1cdpj3377">
            
            Rango de fechas
          </button>
        </div>

        {useDateRange && <div className="grid grid-cols-2 gap-3" data-id="element-6377" data-mp="3d7fptjodrzra">
            <Input label="Desde" type="date" icon={<CalendarIcon className="w-4 h-4" data-id="element-6379" data-mp="3mz29m4esb75n" />} value={dateFrom} onChange={e => setDateFrom(e.target.value)} data-id="element-6378" data-mp="389e8p4aimaig" />
          
            <Input label="Hasta" type="date" icon={<CalendarIcon className="w-4 h-4" data-id="element-6381" data-mp="3w11sl29d0lb8" />} value={dateTo} onChange={e => setDateTo(e.target.value)} data-id="element-6380" data-mp="3i0r05useiyny" />
          
          </div>}

        {statusOptions.length > 0 && <Select label="Estado de la cita" options={statusOptions} value={status} onChange={setStatus} placeholder="Todos los estados" searchable={false} data-id="element-6382" data-mp="1paq0e1q8p9vn" />}

        {patientOptions.length > 0 && <Select label="Paciente" options={patientOptions} value={patientId} onChange={setPatientId} placeholder="Todos los pacientes" searchable data-id="element-6383" data-mp="240e419lw8kmj" />}
      </div>
    </Modal>;
}